<header class="deloitte-header">
    <div class="bg-black text-white">
        <div class="container">
            <div class="row" [ngClass]="{'invisible': !loggedIn }">
                <div class="col text-right">
                    <ul class="navbar-nav pr-3">
                        <li class="nav-item pt-0">
                        <li class="nav-item pt-2">
                            <small>
                                Welcome {{ usersName }}
                                @if (multiplePortals) {
                                <span class="text-white"
                                      routerLink="businessfunctionselector">
                                    <strong class="pointer">
                                        | Change
                                        Portal
                                    </strong>
                                </span>
                                } |
                                <a (click)="signOutClicked()">
                                    <strong class="pointer">
                                        Sign out
                                    </strong>
                                </a>
                            </small>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="navbar navbar-toggleable-md navbar-deloitte pt-0">
        <div class="navbar-container">

            <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse"
                    data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false"
                    aria-label="Toggle navigation" (click)="toggleMenu()">
                <span class="fa fa-bars" [ngClass]="{'fa-bars' : hideMenu, 'fa-close' : !hideMenu}"></span>
                <!-- <span class="fa fa-close"></span> -->
            </button>

            @if (beSpokeLogo != '/images/deloitte.svg') {
            <a [routerLink]="['/'+homeRouteLink]">
                <img [src]="beSpokeLogo" class="bespokeLogoDimension" title="Deloitte" />
            </a>
            }

            @if (beSpokeLogo == '/images/deloitte.svg') {
            <a [routerLink]="['/'+homeRouteLink]" class="navbar-brand">
                <img [src]="beSpokeLogo" title="Deloitte" />
            </a>
            }

            <div class="navbar-collapse justify-content-end" id="navbarNavDropdown" [ngClass]="{'collapse': hideMenu}">

                <ul class="navbar-nav">
                    @for (route of routes; track route; let i = $index) {
                    <li class="nav-item" [routerLinkActive]="['active']"
                        [routerLinkActiveOptions]="{exact: isTrue(route.data['nav'].text)}" (click)="closeMenu()">
                        <a class="nav-link" [routerLink]="[route.data['nav'].navPath]">
                            {{route.data["nav"].text}}
                        </a>
                    </li>
                    }
                </ul>
            </div>
        </div>
    </div>
</header>